import { css } from 'lit';
const styles = css `
.grain-theme--dark {
--grain-global-breakpoint-sm: 320px;
--grain-global-breakpoint-md: 720px;
--grain-global-breakpoint-lg: 992px;
--grain-global-breakpoint-xl: 1200px;
--grain-global-breakpoint-xxl: 1920px;
--grain-global-color-black-100: #000000;
--grain-global-color-black-lighten-20: #333333;
--grain-global-color-black-lighten-80: #cccccc;
--grain-global-color-white-100: #ffffff;
--grain-global-color-white-darken-20: #cccccc;
--grain-global-color-white-darken-80: #333333;
--grain-global-color-gray-100: #f6f6f6;
--grain-global-color-gray-150: #DDDDDD;
--grain-global-color-gray-200: #DDDDDD;
--grain-global-color-gray-250: #C0C0C0;
--grain-global-color-gray-300: #c0c0c0;
--grain-global-color-gray-350: #AAAAAA;
--grain-global-color-gray-400: #aaaaaa;
--grain-global-color-gray-500: #dddddd;
--grain-global-color-gray-550: #737373;
--grain-global-color-gray-600: #737373;
--grain-global-color-gray-700: #444444;
--grain-global-color-gray-750: #444444;
--grain-global-color-gray-800: #222222;
--grain-global-color-gray-850: #222222;
--grain-global-color-gray-900: #111111;
--grain-global-color-gray-950: #111111;
--grain-global-color-gray-050: #F6F6F6;
--grain-global-color-blue-100: #789db8;
--grain-global-color-blue-200: #1347ff;
--grain-global-color-blue-300: #0000ff;
--grain-global-color-blue-400: #3F5B6F;
--grain-global-color-preset-standard-0: #444444;
--grain-global-color-preset-standard-a: #aa3326;
--grain-global-color-preset-standard-acg: #000000;
--grain-global-color-preset-standard-aga: #219166;
--grain-global-color-preset-standard-al: #612010;
--grain-global-color-preset-standard-b: #de5539;
--grain-global-color-preset-standard-bbma: #2ff4da;
--grain-global-color-preset-standard-c: #e26b3c;
--grain-global-color-preset-standard-cg: #dc3300;
--grain-global-color-preset-standard-ch: #0000ff;
--grain-global-color-preset-standard-d: #50e3e1;
--grain-global-color-preset-standard-dog: #8a7661;
--grain-global-color-preset-standard-e: #eea237;
--grain-global-color-preset-standard-f: #fae547;
--grain-global-color-preset-standard-filmx: #ffffff;
--grain-global-color-preset-standard-g: #c8ca34;
--grain-global-color-preset-standard-grey: #373737;
--grain-global-color-preset-standard-h: #7fad3b;
--grain-global-color-preset-standard-hb: #a5acb2;
--grain-global-color-preset-standard-ind: #040e69;
--grain-global-color-preset-standard-j: #568f34;
--grain-global-color-preset-standard-lv: #00a297;
--grain-global-color-preset-standard-k: #397e3e;
--grain-global-color-preset-standard-m: #215652;
--grain-global-color-preset-standard-n: #124863;
--grain-global-color-preset-standard-null: #222222;
--grain-global-color-preset-standard-oak: #0000ff;
--grain-global-color-preset-standard-p: #1e69a2;
--grain-global-color-preset-standard-q: #257cbf;
--grain-global-color-preset-standard-s: #76afdc;
--grain-global-color-preset-standard-se: #0e1c33;
--grain-global-color-preset-standard-sum: #710905;
--grain-global-color-preset-standard-t: #b3cbe8;
--grain-global-color-preset-standard-tech: #d22329;
--grain-global-color-preset-standard-u: #5e6874;
--grain-global-color-preset-standard-v: #9012fe;
--grain-global-color-preset-standard-we: #000000;
--grain-global-color-preset-standard-x: #b288a9;
--grain-global-color-preset-standard-inf: #8c8278;
--grain-global-color-preset-standard-ir: #ba063c;
--grain-global-color-preset-standard-jm: #18b4d3;
--grain-global-color-preset-standard-kk: #ff2133;
--grain-global-color-preset-standard-l: #1ea544;
--grain-global-color-preset-standard-mtv: #0000ff;
--grain-global-color-preset-standard-nc: #000000;
--grain-global-color-preset-standard-oc: #000000;
--grain-global-color-preset-standard-pb: #d2142a;
--grain-global-color-preset-standard-ss: #00ff80;
--grain-global-color-preset-standard-tk: #000000;
--grain-global-color-preset-standard-wwf: #197daf;
--grain-global-color-preset-filmx-au: #601cbf;
--grain-global-color-preset-filmx-av: #e11f29;
--grain-global-color-preset-filmx-fa: #2b4297;
--grain-global-color-preset-filmx-ff: #3c2377;
--grain-global-color-preset-filmx-fn: #54a547;
--grain-global-color-preset-filmx-fp: #149627;
--grain-global-color-preset-filmx-fr: #24349d;
--grain-global-color-preset-filmx-fs: #268e36;
--grain-global-color-preset-filmx-ft: #ed101f;
--grain-global-color-preset-filmx-fv: #0056c7;
--grain-global-color-preset-filmx-ih: #000000;
--grain-global-color-preset-filmx-ka: #4161ac;
--grain-global-color-preset-filmx-kc: #f9b700;
--grain-global-color-preset-filmx-kcp: #e9a108;
--grain-global-color-preset-filmx-ke: #983503;
--grain-global-color-preset-filmx-kg: #0092e1;
--grain-global-color-preset-filmx-kp: #b256b1;
--grain-global-color-preset-filmx-kt: #5b9171;
--grain-global-color-preset-filmx-ku: #de1c73;
--grain-global-color-preset-filmx-kx: #5b9171;
--grain-global-color-hsl-blue-100: linear-gradient(270deg, #03fff3 0%, #5400f3 100%);
--grain-global-color-hsl-blue-200: linear-gradient(90deg, #002a36 0%, #00c8f8 70.27%);
--grain-global-color-hsl-blue-300: linear-gradient(270deg, #555f66 0%, #03aad4 100%);
--grain-global-color-hsl-green-100: linear-gradient(270deg, #fee538 0%, #00ffec 100%);
--grain-global-color-hsl-green-200: linear-gradient(90deg, #022e00 0%, #0bd600 70.27%);
--grain-global-color-hsl-green-300: linear-gradient(270deg, #536353 0%, #14ff00 100%);
--grain-global-color-hsl-purple-100: linear-gradient(270deg, #5d00ff 0%, #ff0c99 100%);
--grain-global-color-hsl-purple-200: linear-gradient(90deg, #4c0049 0%, #f18aed 70.27%);
--grain-global-color-hsl-purple-300: linear-gradient(270deg, #7a5f78 0%, #ff06ff 100%);
--grain-global-color-hsl-red-100: linear-gradient(270deg, #fe0f91 0%, #fa3400 100%);
--grain-global-color-hsl-red-200: linear-gradient(90deg, #52001a 0%, #ff9cac 70.27%);
--grain-global-color-hsl-red-300: linear-gradient(270deg, #79535a 0%, #fe0263 100%);
--grain-global-color-hsl-yellow-100: linear-gradient(270deg, #f5a100 0%, #e2e423 100%);
--grain-global-color-hsl-yellow-200: linear-gradient(270deg, #342700 29.73%, #f4c500 100%);
--grain-global-color-hsl-yellow-300: linear-gradient(270deg, #6c675b 0%, #f3da03 100%);
--grain-global-color-hsl-shadow-100: linear-gradient(90deg, #dedede 0%, #9ceeff 100%);
--grain-global-color-hsl-shadow-200: linear-gradient(90deg, #dedede 0%, #c58fce 100%);
--grain-global-color-hsl-shadow-300: #444444;
--grain-global-color-hsl-shadow-400: linear-gradient(90deg, #dedede 0%, #fc7474 100%);
--grain-global-color-hsl-shadow-500: linear-gradient(90deg, #dedede 0%, #96dc9f 100%);
--grain-global-color-hsl-shadow-600: linear-gradient(90deg, #dedede 0%, #fff489 100%);
--grain-global-color-hsl-shadow-700: linear-gradient(90deg, #dedede 0%, #f69e56 100%);
--grain-global-color-hsl-temperature-100: linear-gradient(270deg, #ffcb00 0%, #ffffff 47.76%, #2e99ff 100%);
--grain-global-color-hsl-tint-100: linear-gradient(90deg, #1f8b4c 0%, #ffffff 50.11%, #ff4abe 100%);
--grain-global-color-border-black: #000000;
--grain-global-color-border-white: #ffffff;
--grain-global-color-border-blue-100: #71c5d6;
--grain-global-color-border-blue-200: #1d71d8;
--grain-global-color-border-blue-300: #1d71d8;
--grain-global-color-border-gold-100: #ae995a;
--grain-global-color-border-grey-100: #c6c7bf;
--grain-global-color-border-grey-200: #8c8d87;
--grain-global-color-border-green-100: #81d281;
--grain-global-color-border-green-200: #44b344;
--grain-global-color-border-green-300: #007000;
--grain-global-color-border-orange-100: #f48022;
--grain-global-color-border-orange-200: #ff5f06;
--grain-global-color-border-pink-100: #ffaebb;
--grain-global-color-border-red-100: #ff4d4d;
--grain-global-color-border-red-200: #ff3400;
--grain-global-color-border-purple-100: #96398e;
--grain-global-color-border-yellow-100: #ffcd00;
--grain-global-color-red-100: #FF4928;
--grain-global-color-red-200: #F73100;
--grain-global-color-saffron-100: #FFC53C;
--grain-global-color-saffron-200: #F1A900;
--grain-global-color-gold-100: #EDBA58;
--grain-global-color-gold-200: #AE995A;
--grain-global-color-typography-text-primary: #ffffff;
--grain-global-color-typography-text-secondary: #c0c0c0;
--grain-global-color-typography-text-tertiary: #737373;
--grain-global-color-typography-text-error: #ff4d4d;
--grain-global-color-typography-preset-default: #c0c0c0;
--grain-global-color-typography-preset-hover: #dddddd;
--grain-global-color-typography-preset-active: #ffffff;
--grain-global-color-icon-primary: #ffffff;
--grain-global-color-icon-secondary: #737373;
--grain-global-color-icon-tertiary: #000000;
--grain-global-color-icon-hover: #aaaaaa;
--grain-global-color-icon-pressed: #dddddd;
--grain-global-color-icon-background: #111111;
--grain-global-color-icon-error: #ff3400;
--grain-global-color-background-1: #000000;
--grain-global-color-background-2: #111111;
--grain-global-color-button-primary-text: #000000;
--grain-global-color-button-primary-fill: #ffffff;
--grain-global-color-button-primary-hover: #c0c0c0;
--grain-global-color-button-link-primary-active: #cccccc;
--grain-global-color-button-link-primary-text: #000000;
--grain-global-color-button-link-primary-hover: #999999;
--grain-global-space-1: 4;
--grain-global-space-2: 8;
--grain-global-space-3: 12;
--grain-global-space-4: 16;
--grain-global-space-5: 24;
--grain-global-space-6: 32;
--grain-global-space-7: 40;
--grain-global-space-8: 48;
--grain-global-space-9: 54;
--grain-global-space-10: 60;
--grain-global-space-11: 64;
--grain-global-space-12: 72;
--grain-global-space-13: 80;
--grain-global-borderRadius-0: 0;
--grain-global-borderRadius-2: 2;
--grain-global-borderRadius-4: 4;
--grain-global-borderRadius-8: 8;
--grain-global-borderRadius-16: 16;
--grain-global-borderRadius-24: 24;
--grain-global-borderRadius-100: 100;
--grain-global-borderRadius-full: 100;
--grain-global-fontFamily-vscoGothic: 'VSCO Gothic', var(--grain-global-fontFamily-systemFont);
--grain-global-fontFamily-systemFont: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif';
--grain-global-textCase-capitalize: capitalize;
--grain-global-textCase-none: none;
--grain-global-textCase-underline: underline;
--grain-global-textCase-uppercase: uppercase;
--grain-global-lineHeight-100: 17;
--grain-global-lineHeight-200: 21;
--grain-global-lineHeight-300: 28;
--grain-global-fontSize-0: 10;
--grain-global-fontSize-1: 13;
--grain-global-fontSize-2: 15;
--grain-global-fontSize-3: 21;
--grain-global-fontSize-100: 10;
--grain-global-fontSize-200: 13;
--grain-global-fontSize-300: 15;
--grain-global-fontSize-400: 21;
--grain-global-letterSpacing-0: 0;
--grain-global-letterSpacing-1: 10%;
--grain-global-letterSpacing-10: 10%;
--grain-global-paragraphSpacing-0: 0;
--grain-global-paragraphSpacing-1: 8;
--grain-global-paragraphSpacing-100: 8;
--grain-global-indent-0: 0px;
--grain-global-textDecoration-none: none;
--grain-global-textDecoration-underline: underline;
--grain-global-fontWeight-100: 100;
--grain-global-fontWeight-400: 400;
--grain-global-fontWeight-700: 700;
--grain-global-fontWeight-vscoGothicMedium: 400;
--grain-global-fontWeight-vscoGothicLight: 100;
--grain-global-opacity-10: 10%;
--grain-global-opacity-20: 20%;
--grain-global-opacity-30: 30%;
--grain-global-opacity-40: 40%;
--grain-global-opacity-50: 50%;
--grain-global-opacity-60: 60%;
--grain-global-opacity-70: 70%;
--grain-global-opacity-80: 80%;
--grain-global-opacity-90: 90%;
--grain-global-opacity-100: 100%;
--grain-global-opacity-full: 100%;
--grain-global-opacity-none: 0;
--grain-global-fontFamilies-vsco-gothic: 'VSCO Gothic', var(--grain-global-fontFamily-systemFont);
--grain-global-lineHeights-0: AUTO;
--grain-global-lineHeights-1: 17;
--grain-global-fontWeights-vsco-gothic-0: Medium;
--grain-global-fontWeights-vsco-gothic-1: Light;
--grain-global-paragraphIndent-0: 0px;
--grain-color-typography-text-primary: #ffffff;
--grain-color-typography-text-secondary: #C0C0C0;
--grain-color-typography-text-tertiary: #737373;
--grain-color-typography-text-error: #ff4d4d;
--grain-color-typography-text-warning: #FFC53C;
--grain-color-typography-preset-default: #C0C0C0;
--grain-color-typography-preset-hover: #DDDDDD;
--grain-color-typography-preset-active: #ffffff;
--grain-color-fill-primary: #ffffff;
--grain-color-icon-primary: #ffffff;
--grain-color-icon-secondary: #737373;
--grain-color-icon-tertiary: #000000;
--grain-color-icon-svgFill: #737373;
--grain-color-icon-hover: #AAAAAA;
--grain-color-icon-pressed: #DDDDDD;
--grain-color-icon-background: #111111;
--grain-color-icon-error: #ff3400;
--grain-color-icon-warning: #FFC53C;
--grain-color-background-1: #000000;
--grain-color-background-2: #222222;
--grain-color-button-primary-text: #000000;
--grain-color-button-primary-fill: #ffffff;
--grain-color-button-primary-hover: #C0C0C0;
--grain-color-buttonLink-primary-text: #000000;
--grain-color-buttonLink-primary-active: #DDDDDD;
--grain-color-buttonLink-primary-hover: #AAAAAA;
--grain-color-membership-pro: #EDBA58;
--grain-color-membership-plus: #789db8;
}
`;
export default styles;
